define('fukit/view/block/image',['require','exports','module','uikit/uikit','../../templates'],function(require, exports, module) {
  //prettier-ignore
  var UIKit     = require('uikit/uikit'),
      Templates = require('../../templates');

  var ImageView = UIKit.ItemView.extend({
    template: Templates.FuKit['image'],
    options: {
      url: undefined,
      svgData: undefined,
      attributes: undefined,
    },
  });

  module.exports = ImageView;
});

